"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = void 0;
exports.path = '/service-center-node-service-issue-resolution-actions-add';
//# sourceMappingURL=index.js.map